import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';
import { ThemeModeProvider } from './context/ThemeMode/ThemeModeProvider';
import { GritThemeProvider } from './theme/GritThemeProvider';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

window.addEventListener('unhandledrejection', (event) => {
  console.error('[UnhandledRejection]', event.reason);
});

root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <GritThemeProvider>
        <App />
      </GritThemeProvider>
    </ThemeModeProvider>
  </React.StrictMode>
);
